__turbopack_context__.v({
  "articleTimeAgo": "sjU00q_articleTimeAgo",
  "articleTitle": "sjU00q_articleTitle",
  "articleTopic": "sjU00q_articleTopic",
  "banner": "sjU00q_banner",
  "card": "sjU00q_card",
  "cardFooter": "sjU00q_cardFooter",
  "empty": "sjU00q_empty",
  "icon": "sjU00q_icon",
  "list": "sjU00q_list",
  "listHeader": "sjU00q_listHeader",
  "listWrapper": "sjU00q_listWrapper",
  "name": "sjU00q_name",
  "nameWrapper": "sjU00q_nameWrapper",
  "negative": "sjU00q_negative",
  "newsHeader": "sjU00q_newsHeader",
  "newsList": "sjU00q_newsList",
  "newsWrapper": "sjU00q_newsWrapper",
  "oops": "sjU00q_oops",
  "percent": "sjU00q_percent",
  "positive": "sjU00q_positive",
  "price": "sjU00q_price",
  "row": "sjU00q_row",
  "text": "sjU00q_text",
  "ticker": "sjU00q_ticker",
  "wrapper": "sjU00q_wrapper",
  "wrapperGradient": "sjU00q_wrapperGradient",
});
